module.exports = __webpack_public_path__ + "img/souls.06dc216d.svg";